interface IBusqueda {
  $id: string;
  $priority?: number;
  asunto?: string;
  bb?: string;
  bb_enviado?: boolean;
  bb_enviado_descripcion?: string;
  busqueda?: string;
  campoEncontrado?: string;
  comentarios?: any;
  delegado?: string;
  delegado_correo?: string;
  delegado_descripcion?: string;
  descripcion?: string;
  encontrado?: boolean;
  end?: string;
  estatus?: string;
  estatus_descripcion?: string;
  fechaFin?: string;
  fechaInicio?: string;
  matches?: any;
  modo_entrada?: string;
  modo_entrada_descripcion?: string;
  prioridad?: number;
  prioridad_descripcion?: string;
  recordatorios?: any;
  remitente?: string;
  remitente_correo?: string;
  remitente_descripcion?: string;
  remitente_enviado?: boolean;
  start?: string;
  tamBusqueda?: number;
  tema?: string;
  tema_descripcion?: string;
  tipo?: string;
  tipo_descripcion?: string;
  tsCreation?: string;
  tsLastUpdate?: string;
  uid?: string;
  vip?: boolean;
  historico?: any;
}

export interface IBusquedaState {
  busqueda: string;
  ids: any[];
  entradas: any[];
  pages: number;
  currentPage: number;
  tipoBusqueda: string;
  error: boolean;
  entradaSeleccionada?: any;
}

export const IBusquedaInitState: IBusquedaState = {
  busqueda: "",
  ids: [],
  entradas: [],
  pages: 0,
  currentPage: 0,
  tipoBusqueda: "",
  error: false,
  entradaSeleccionada: {},
};

export interface IBusquedaRequest {
  buscar: string;
  idsTemas: string[];
}

export interface IComentario {
  id?: string;
  bb?: boolean;
  bb_enviado?: string;
  bb_enviado_descripcion?: string;
  descripcion?: string;
  fecha?: string;
  tema?: string;
  tsCreation?: string;
  tsLastUpdate?: string;
  usuario?: string;
}

export interface IRequestBusquedaAvanzada {
  paramsBusqueda: ParamsBusqueda;
}

export interface ParamsBusqueda {
  tema_descripcion?: string[];
  tipo_descripcion?: string[];
  modo_entrada_descripcion?: string[];
  prioridad_descripcion?: string[];
  remitente_descripcion?: string[];
  delegado_descripcion?: string[];
  remitente_enviado_descripcion?: string[];
  conCopia_descripcion?: string[];
  empresa_descripcion?: string[];
  estatus_descripcion?: string[];
  fechaInicioDesde?: string;
  fechaFinDesde?: string;
  fechaInicioHasta?: string;
  fechaFinHasta?: string;
  idsTemas?: string[];
  texto:string
}
